import {attributeTypeCodes} from '@/enums/customAttributeTypeCodes'

export const attributesMixin = {
  methods: {
    addAttributesToFormFields() {
      this.formFields.push(
        ...this.attributes.map((attribute) => {
          const convertedAttribute = this.convertAtrribute(attribute)
          convertedAttribute.value = this.formatAttributeValue(attribute)
          return convertedAttribute
        })
      )
    },
    formatAttributeValue(attribute){
      if(attribute.value > 0){
        switch(attribute.attributeTypeCode){
          case attributeTypeCodes.N_DECIMAL:
            return parseFloat(attribute.value)
          default:
            return parseInt(attribute.value)
        }
      }
      else{
        switch (attribute.attributeTypeCode) {
          case attributeTypeCodes.T_SHORT:
          case attributeTypeCodes.F_GEN:
            return attribute.value
          default:
            return null
        }
      }
    },

    convertAtrribute(attribute) {
      return {
        label: attribute.displayName,
        fieldName: attribute.code,
        isVisible: attribute.showInProductCatalog,
        items: (JSON.parse(attribute.options) || []).map((option) => {
          return {
            text: option.Name,
            value: option.ID,
            image: option.imageUrl,
          }
        }),
        controlType: this.getAttributeFieldType(attribute),
        fieldType: 'ATTRIBUTE',
        isMandatory: attribute.isMandatory,
        value:
          isNaN(parseInt(attribute.value || attribute.value)) &&
          attribute.attributeTypeCode === attributeTypeCodes.T_SHORT
            ? attribute.valueStr
            :  (attribute.attributeTypeCode === attributeTypeCodes.DATE
                ? null
                : parseInt(attribute.value) || attribute.value
            ),
        linkValue:
          attribute.attributeTypeCode === attributeTypeCodes.LINK
            ? attribute.value
            : null,
        fileName: attribute.value,
        measureUnitSymbol: attribute.measureUnitSymbol,
        decimalPrecision: attribute.decimalPrecision,
      }
    },
    getAttributeFieldType(attribute) {
      let type = ''
      switch (attribute.attributeTypeCode) {
        case 'BOOL':
          type = attributeTypeCodes.BOOL
          break
        case 'LINK':
          type = attributeTypeCodes.LINK
          break
        case 'LIST':
          type = attributeTypeCodes.LIST
          break
        case 'T_SHORT':
          type = attributeTypeCodes.T_SHORT
          break
        case 'T_LONG':
          type = attributeTypeCodes.TEXT
          break
        case 'N_INT':
          type = attributeTypeCodes.NUM_INT
          break
        case 'N_DECIMAL':
          type = attributeTypeCodes.NUM_DECIMAL
          break
        case 'F_GEN':
          type = attributeTypeCodes.F_GEN
          break
        case 'F_IMG':
          type = attributeTypeCodes.F_IMG
          break
        case 'F_LS_IMG':
          type = attributeTypeCodes.F_LS_IMG
          break
        case 'DATE':
          type = attributeTypeCodes.DATE
          break
      }
      return type
    },
    buildOptionsForListAttribute(attribute) {
      return (JSON.parse(attribute.options) || []).map((option) => {
        return {
          text: option.Name,
          value: option.ID,
          code: option.Code,
          image: `${this.$config.axios.browserBaseURL}labellistitems/${option.ID}/image`,
          visible: true,
          dependencyItem1: option.Dependency_Items_1,
          dependencyItem2: option.Dependency_Items_2,
          dependencyItem3: option.Dependency_Items_3,
        }
      })
    },
    mapAttributeValue(attribute) {
      let value = attribute.value
      if (attribute.attributeTypeCode === attributeTypeCodes.LIST) {
        const options = this.buildOptionsForListAttribute(attribute)
        const currentlySelected = options.find((o) => o.value === parseInt(attribute.value))
        value = currentlySelected ? currentlySelected.text : ''
      }
      return {
        ...attribute,
        value: attribute.value
          ? value
          : attribute.valueText,
      }
    },
  },
}
